import "bootstrap/dist/css/bootstrap.min.css";
import { get, ref } from "firebase/database";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../Firebase";
import HoldAction from "./HoldAction";
import RemoveHold from "./RemoveHold";

const RegistrationData = () => {
  const [searchId, setSearchId] = useState("");
  const [registrationData, setRegistrationData] = useState(null);
  const [registrationMeta, setRegistrationMeta] = useState(null);
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (!searchId.trim()) return alert("Please enter a registration ID");
    
    const snap = await get(ref(db, `registration/${searchId}`));
    if (!snap.exists()) return alert("No data found for this ID");

    const data = snap.val();
    setRegistrationData(data.basic || {});
    setRegistrationMeta(data.meta || {});
    const mem = data.members || {};
    setMembers(Object.entries(mem).map(([k, v]) => ({ key: k, ...v })));
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Search Header */}
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <h4 style={{ color: '#333', marginBottom: '15px' }}>🔍 Search Registration</h4>
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            type="text"
            placeholder="Enter Registration ID"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            style={{
              flex: 1,
              padding: "10px",
              border: "1px solid #dee2e6",
              borderRadius: "4px",
              fontSize: "14px"
            }}
          />
          <button
            onClick={handleSearch}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "500"
            }}
          >
            🔎 Search
          </button>
        </div>
      </div>

      {registrationData && (
        <>
          {/* Basic Details */}
          <div style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            marginBottom: "20px"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h5 style={{ color: "#333", margin: 0 }}>📋 Registration Details - {searchId}</h5>
              <div style={{ display: "flex", gap: "10px" }}>
                {registrationMeta?.status === 'hold' ? (
                  <RemoveHold registrationId={searchId} />
                ) : (
                  <HoldAction registrationId={searchId} currentStatus={registrationMeta?.status} />
                )}
                <button
                  onClick={() => navigate(`/edit-registration/${searchId}/basic`)}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500"
                  }}
                >
                  ✏️ Edit
                </button>
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px"
              }}>
                <tbody>
                  {Object.entries(registrationData).map(([key, value]) => (
                    <tr key={key} style={{ borderBottom: "1px solid #dee2e6" }}>
                      <th style={{
                        width: "25%",
                        padding: "12px",
                        textAlign: "left",
                        backgroundColor: "#f8f9fa",
                        fontWeight: "600",
                        color: "#333",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {key}
                      </th>
                      <td style={{
                        padding: "12px",
                        color: "#555"
                      }}>
                        {String(value || '-')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Meta Details */}
          {Object.keys(registrationMeta).length > 0 && (
            <div style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              marginBottom: "20px"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <h5 style={{ color: "#333", margin: 0 }}>📌 Meta Information</h5>
                <button
                  onClick={() => navigate(`/edit-registration/${searchId}/meta`)}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500"
                  }}
                >
                  ✏️ Edit
                </button>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px"
                }}>
                  <tbody>
                    {Object.entries(registrationMeta).map(([key, value]) => (
                      <tr key={key} style={{ borderBottom: "1px solid #dee2e6" }}>
                        <th style={{
                          width: "25%",
                          padding: "12px",
                          textAlign: "left",
                          backgroundColor: "#f8f9fa",
                          fontWeight: "600",
                          color: "#333",
                          borderRight: "1px solid #dee2e6"
                        }}>
                          {key}
                        </th>
                        <td style={{
                          padding: "12px",
                          color: "#555"
                        }}>
                          {typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value || '-')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Members */}
          {members.length > 0 && (
            <div style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              marginBottom: "20px"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <h5 style={{ color: "#333", margin: 0 }}>👨👩👧👦 Family Members ({members.length})</h5>
                <button
                  onClick={() => navigate(`/edit-registration/${searchId}/members`)}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500"
                  }}
                >
                  ✏️ Edit Members
                </button>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px"
                }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                      <th style={{
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#333",
                        width: "50px",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        #
                      </th>
                      {members.length > 0 && Object.keys(members[0]).filter(k => k !== 'key').map(key => (
                        <th key={key} style={{
                          padding: "12px",
                          textAlign: "left",
                          fontWeight: "600",
                          color: "#333",
                          borderRight: "1px solid #dee2e6"
                        }}>
                          {key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {members.map((member, idx) => (
                      <tr key={member.key} style={{
                        borderBottom: "1px solid #dee2e6",
                        backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f8f9fa"
                      }}>
                        <td style={{
                          padding: "12px",
                          textAlign: "center",
                          fontWeight: "500",
                          color: "#666",
                          borderRight: "1px solid #dee2e6"
                        }}>
                          {idx + 1}
                        </td>
                        {Object.entries(member).filter(([k]) => k !== 'key').map(([key, value]) => (
                          <td key={key} style={{
                            padding: "12px",
                            color: "#555",
                            borderRight: "1px solid #dee2e6"
                          }}>
                            {typeof value === 'object' ? JSON.stringify(value).substring(0, 30) : String(value || '-')}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}

      {!registrationData && (
        <div style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          textAlign: "center",
          color: "#999"
        }}>
          🔍 Search for a registration ID to view details
        </div>
      )}
    </div>
  );
};

export default RegistrationData;